// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--11-2!../../../node_modules/sass-loader/dist/cjs.js??ref--11-3!./teke-order-review.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("311203d0", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/views/teke-order-review/teke-order-review.scss
// module id = 5579
// module chunks = 34